var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2024 0.79797C16.6907 0.286996 15.9971 0 15.2739 0C14.5507 0 13.8571 0.286996 13.3454 0.79797L1.10278 13.0408C0.75219 13.3894 0.47421 13.8041 0.284923 14.2609C0.0956352 14.7176 -0.00120286 15.2074 1.1277e-05 15.7018V17.2472C1.1277e-05 17.4469 0.0793178 17.6383 0.220484 17.7795C0.361651 17.9207 0.553114 18 0.752753 18H2.29813C2.79251 18.0014 3.28224 17.9047 3.739 17.7155C4.19575 17.5264 4.61045 17.2485 4.95907 16.8979L17.2024 4.65435C17.7132 4.14262 18 3.44916 18 2.72616C18 2.00316 17.7132 1.3097 17.2024 0.79797ZM3.8947 15.8335C3.47015 16.2553 2.89653 16.4927 2.29813 16.4945H1.5055V15.7018C1.50473 15.4052 1.56282 15.1113 1.6764 14.8372C1.78997 14.5632 1.95678 14.3144 2.16716 14.1052L11.4582 4.81393L13.1896 6.54527L3.8947 15.8335ZM16.1373 3.58995L14.2509 5.47711L12.5196 3.74577L14.4067 1.85861C14.6363 1.62902 14.9477 1.50003 15.2724 1.50003C15.4332 1.50003 15.5924 1.5317 15.7409 1.59322C15.8894 1.65475 16.0244 1.74492 16.138 1.85861C16.2517 1.97229 16.3419 2.10725 16.4034 2.25578C16.4649 2.40431 16.4966 2.56351 16.4966 2.72428C16.4966 2.88505 16.4649 3.04424 16.4034 3.19277C16.3419 3.34131 16.2517 3.47627 16.138 3.58995H16.1373Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.92b6a18d841cc8ad9d8493b4d2af2804.svg";
export { ForwardRef as ReactComponent };